import React from 'react';
import { translations } from '../translations';
import '../styles/pages/About.css';
import DysOrtoPath from '../assets/images/DysOrtoPath.png';
import MissionPath from '../assets/images/mission.png';

function About({ language }) {
  const t = translations[language];

  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>{t.aboutTitle}</h1>
        <p>{t.aboutSubtitle}</p>
      </div>

      <section className="about-section">
        <div className="about-grid">
          <div className="about-content">
            <h2>{t.ourMission}</h2>
            <p>{t.missionText1}</p>
            <p>{t.missionText2}</p>
          </div>
          <div className="about-image">
            <img src={MissionPath} alt={t.missionImageAlt} />
          </div>
        </div>
      </section>

      {/* <section className="about-section">
        <div className="about-grid">
          <div className="about-image">
            <img src={DysOrtoPath} alt={t.storyImageAlt} />
          </div>
          <div className="about-content">
            <h2>{t.ourStory}</h2>
            <p>{t.storyText1}</p>
            <p>{t.storyText2}</p>
          </div>
        </div>
      </section> */}

      <section className="team-section">
        <h2>{t.ourTeam}</h2>
        <div className="team-text-wrapper">
          <div className="team-text-column">
            <h3>{t.teamMemberName1}</h3>
            <p>{t.teamText1}</p>
          </div>
          <div className="team-text-column">
            <h3>{t.teamMemberName2}</h3>
            <p>{t.teamText2}</p>
          </div>
        </div>
        <div className="team-text-shared">
          <p>{t.teamTextShared}</p>
        </div>
      </section>
    </div>
  );
}

export default About;
